export const RELATION_KEY = '__to:__';
